import { render } from "./shopifyOrder.vue?vue&type=template&id=72e067d7&scoped=true"
import script from "./shopifyOrder.vue?vue&type=script&lang=js"
export * from "./shopifyOrder.vue?vue&type=script&lang=js"

import "./shopifyOrder.vue?vue&type=style&index=0&id=72e067d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e067d7"]])

export default __exports__